import {gsap} from "../../lib/gsap";

export default class CursorFollower {
	static init() {

		document.querySelectorAll(".cursor-follower").forEach(follower => {

			const container = follower.closest('.cursor-follower-inner');
			if( container ){

				const setX = gsap.quickTo(follower, "left", { duration: 0.28, ease: "power3.out" });
				const setY = gsap.quickTo(follower, "top", { duration: 0.28, ease: "power3.out" });
				const links = container.querySelectorAll('a:not(.text), .gallery-zoom');

				container.addEventListener('mousemove', (e) => {
					const r = container.getBoundingClientRect();
					let x = e.clientX - r.left;
					let y = e.clientY - r.top;
					setX(x);
					setY(y);
				});

				container.addEventListener('mouseenter', (e) => {
					gsap.to(follower, { opacity: 1, scale: 1, duration: 0.2, ease: "power2.out" });
				});

				container.addEventListener('mouseleave', (e) => {
					gsap.to(follower, { opacity: 0, scale: 0.6, duration: 0.2, ease: "power2.out" });
				});

				links.forEach( link  => {
					link.addEventListener('mouseenter', (e) => {
						gsap.to(follower, { opacity: 0, scale: .6, duration: 0.2, ease: "power2.out" });
					});
					link.addEventListener('mouseleave', (e) => {
						gsap.to(follower, { opacity: 1, scale: 1, duration: 0.2, ease: "power2.out" });
					});
				});

			}

		});

	}

}
